// Columns of the All LPs table. `sortKey` must match
// SalesforceAccountsListService::SORTABLE_COLUMNS in alps-be; `type` drives the cell renderer.
export const LP_COLUMNS = [
	{
		label: 'Account',
		sortKey: 'name',
		field: 'name',
		type: 'account',
		minWidth: 200,
	},
	{
		label: 'Investor Type',
		sortKey: 'investor_type',
		field: 'investor_type',
		minWidth: 140,
	},
	{
		label: 'Coverage Tier',
		sortKey: 'coverage_tier',
		field: 'coverage_tier',
		align: 'center',
		minWidth: 130,
	},
	{
		label: 'Internal Coverage',
		sortKey: 'internal_coverage',
		field: 'internal_coverage',
		minWidth: 160,
	},
	{
		label: '# of Active Fundraising',
		sortKey: 'active_fundraising_count',
		field: 'active_fundraising_count',
		type: 'count',
		align: 'center',
		minWidth: 180,
	},
	{
		label: '# of Investor Commitments',
		sortKey: 'investor_commitment_count',
		field: 'investor_commitment_count',
		type: 'count',
		align: 'center',
		minWidth: 200,
	},
	{
		label: 'Health',
		sortKey: 'health',
		field: 'health',
		type: 'health',
		align: 'center',
		minWidth: 90,
	},
	{
		label: 'Last Interaction Date',
		sortKey: 'last_interaction_date',
		field: 'last_interaction_date',
		type: 'date',
		minWidth: 180,
	},
];

export const LP_SORT_KEYS = LP_COLUMNS.filter(({ sortKey }) => sortKey).map(
	({ sortKey }) => sortKey
);

// Filter keys sent to the API. Blank means the dropdown's "All" option.
export const LP_INITIAL_FILTERS = {
	investor_type: '',
	coverage_tier: '',
	internal_coverage: '',
	health: '',
};
